import Vue from "vue";
import Router from "vue-router";

import HomePage from "@/components/homePage.vue";

const Campeonatos = () =>
  import("@/components/Championships/championships.vue");
// import Campeonatos from '@/components/Championships/championships.vue'
const NovoCampeonato = () =>
  import("@/components/Championships/newChampionships.vue");
// import NovoCampeonato from '@/components/Championships/newChampionships.vue'
const Entrar = () => import("@/components/Users/login.vue");
// import Entrar from '@/components/Users/login.vue'
const Sair = () => import("@/components/Users/logout.vue");
// import Sair from '@/components/Users/logout.vue'
const Registrar = () => import("@/components/Users/signIn.vue");
// import Registrar from '@/components/Users/signIn.vue'
const Perfil = () => import("@/components/Users/users.vue");
// import Perfil from '@/components/Users/users.vue'
const OCampeonato = () =>
  import("@/components/Championships/theChampionship.vue");
// import OCampeonato from '@/components/Championships/theChampionship.vue'
// const JogoOffline = () => import('@/components/Championships/ChampionshipDetails/paper.vue')
const JogoOffline = () => import("@/views/Championship/Paper.vue");
// import JogoOffline from '@/components/Championships/ChampionshipDetails/paper.vue'
const JogoTempoReal = () =>
  import("@/components/Championships/ChampionshipDetails/onlinePaper.vue");
// import JogoTempoReal from '@/components/Championships/ChampionshipDetails/onlinePaper.vue'

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "HomePage",
      component: HomePage,
    },
    {
      path: "/index.html",
      name: "HomePage",
      component: HomePage,
    },
    {
      path: "/campeonatos",
      name: "Campeonatos",
      component: Campeonatos,
      // meta: {
      // auth: true,
      // }
    },
    {
      path: "/campeonatos/novo",
      name: "NovoCampeonato",
      component: NovoCampeonato,
      meta: {
        auth: true,
      },
    },
    {
      path: "/campeonatos/:id",
      name: "OCampeonato",
      component: OCampeonato,
      children: [
        {
          path: "equipes",
          name: "OCampeonatoEquipes",
          component: () =>
            import("./components/Championships/ChampionshipDetails/teams.vue"),
        },
        {
          path: "grupos",
          name: "OCampeonatoGrupos",
          component: () =>
            import("./components/Championships/ChampionshipDetails/groups.vue"),
        },
        {
          path: "jogos",
          name: "OCampeonatoJogos",
          component: () =>
            import(
              "./components/Championships/ChampionshipDetails/gamesRounds.vue"
            ),
          children: [
            {
              path: ":round",
              name: "OCampeonatoRound",
              component: () =>
                import(
                  "./components/Championships/ChampionshipDetails/games.vue"
                ),
            },
          ],
        },
        {
          path: "classificacao",
          name: "OCampeonatoClassific",
          component: () =>
            import(
              "./components/Championships/ChampionshipDetails/classification.vue"
            ),
        },
        {
          path: "estatisticas",
          name: "OCampeonatoEstatisti",
          component: () =>
            import(
              "./components/Championships/ChampionshipDetails/statistics.vue"
            ),
        },
      ],
    },
    {
      path: "/sumula/:id",
      name: "JogoOffline",
      component: JogoOffline,
    },
    {
      path: "/jogo/:id",
      name: "JogoTempoReal",
      component: JogoTempoReal,
    },
    {
      path: "/login",
      name: "Login",
      component: Entrar,
    },
    {
      path: "/logout",
      name: "Logout",
      component: Sair,
    },
    {
      path: "/registrar",
      name: "Registrar",
      component: Registrar,
    },
    {
      path: "/perfil",
      name: "Perfil",
      component: Perfil,
      meta: {
        auth: true,
      },
    },
  ],
});

Vue.router = router;

export default router;
